var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChatDoubleBubble(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2603_39803)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.07872 9.35717C5.02692 9.02336 5.00005 8.68138 5.00005 8.33317C5.00005 4.65127 8.00445 1.6665 11.7106 1.6665C15.4167 1.6665 18.4211 4.65127 18.4211 8.33317C18.4211 9.1649 18.2678 9.96105 17.9877 10.6953C17.9295 10.8477 17.9005 10.924 17.8872 10.9835C17.8742 11.0425 17.8691 11.084 17.8677 11.1444C17.8663 11.2053 17.8745 11.2725 17.8911 11.4068L18.2265 14.1319C18.2629 14.4269 18.281 14.5745 18.2319 14.6817C18.1889 14.7756 18.1126 14.8503 18.0177 14.8911C17.9093 14.9377 17.7623 14.9161 17.4682 14.873L14.8138 14.4839C14.6752 14.4636 14.6059 14.4535 14.5428 14.4538C14.4803 14.4542 14.4371 14.4588 14.376 14.4716C14.3143 14.4846 14.2354 14.5142 14.0776 14.5733C13.3415 14.849 12.5438 14.9998 11.7106 14.9998C11.3621 14.9998 11.0198 14.9734 10.6856 14.9226M6.35973 18.3332C8.83048 18.3332 10.8334 16.2811 10.8334 13.7498C10.8334 11.2185 8.83048 9.1665 6.35973 9.1665C3.88898 9.1665 1.88605 11.2185 1.88605 13.7498C1.88605 14.2587 1.96698 14.7481 2.11637 15.2054C2.17952 15.3988 2.2111 15.4954 2.22146 15.5615C2.23228 15.6304 2.23418 15.6691 2.23015 15.7388C2.22629 15.8055 2.20959 15.8809 2.1762 16.0318L1.66675 18.3332L4.16242 17.9923C4.29864 17.9737 4.36675 17.9644 4.42622 17.9648C4.48885 17.9653 4.52209 17.9687 4.5835 17.9809C4.64183 17.9925 4.72855 18.0231 4.90197 18.0843C5.35891 18.2456 5.84934 18.3332 6.35973 18.3332Z",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2603_39803"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChatDoubleBubble);
export default __webpack_public_path__ + "static/media/chat-double-bubble.c4cdab1c969ebe6d67d4779f3c3b19f7.svg";
export { ForwardRef as ReactComponent };